<div class="modal-wrapper">
    <!-- Close Button -->
    <div class="modal-header-actions">
        <button type="button" (click)="closeModal()" class="btn-close-modal">
            ✕
        </button>
    </div>

    <!-- Content -->
    <div class="modal-content-body" id="pdfTable">
        <div *ngFor="let form of formList; let i = index" class="bulletin-container" [id]="'pdfTable' + i">
            
            <h2 class="title">
                BULLETIN INDIVIDUEL D'HÔTEL / HOTEL INDIVIDUAL FORM
            </h2>

            <form class="bulletin-form">
                <h3 class="guest-header">Voyageur / Guest {{ i + 1 }}</h3>

                <div class="form-row">
                    <label>Nom / Name </label>
                    <input type="text" [(ngModel)]="form.nom" name="nom{{i}}" readonly/>
                </div>

                <div class="form-row">
                    <label>Prénom / First Name </label>
                    <input type="text" [(ngModel)]="form.prenom" name="prenom{{i}}" readonly />
                </div>

                <div class="form-row">
                    <label>Date et lieu de naissance / Date and place of birth </label>
                    <input type="text" [(ngModel)]="form.dateNaissance" name="dateNaissance{{i}}" readonly />
                </div>

                <div class="form-row">
                    <label>E-mail</label>
                    <input type="email" [(ngModel)]="form.email" name="email{{i}}" readonly />
                </div>

                <div class="form-row">
                    <label>Numéro de téléphone / Phone number </label>
                    <input type="text" [(ngModel)]="form.telephone" name="telephone{{i}}" readonly />
                </div>

                <div class="form-row">
                    <label>Pays / Country</label>
                    <input type="text" [(ngModel)]="form.pays" name="pays{{i}}" readonly />
                </div>

                <div class="form-row">
                    <label>Nationalité / Nationality </label>
                    <input type="text" [(ngModel)]="form.nationalite" name="nationalite{{i}}" readonly />
                </div>

                <div class="form-row">
                    <label>Profession / Occupation</label>
                    <input type="text" [(ngModel)]="form.profession" name="profession{{i}}" readonly />
                </div>

                <div class="form-row">
                    <label>Adresse / Street Address </label>
                    <input type="text"
                           [(ngModel)]="form.adresse"
                           name="adresse{{i}}"
                           placeholder="Ex: Avenue Hassan II"
                           readonly />
                </div>

                <div class="form-row">
                    <label> Document / Document </label>
                    <input type="text" [value]="form.typeDoc" name="typeDoc{{ i }}" readonly />
                </div>

                <div class="form-row" *ngIf="form.subDocType">
                    <label> Type de document / Document Type </label>
                    <input type="text" [value]="form.subDocType" name="subDocType{{ i }}" readonly />
                </div>

                <div class="form-row">
                    <label>Numéro C.I.N / Passport / ID Number</label>
                    <input type="text" [(ngModel)]="form.code" name="cin{{i}}" readonly />
                </div>

                <div class="form-row">
                    <label>Date Expiration / Expiration Date </label>
                    <input type="text" [value]="form.description" name="description{{ i }}" readonly />
                </div>

                <div class="form-row">
                    <label>Numéro d'entrée au Maroc / Entry Number </label>
                    <input type="text" [(ngModel)]="form.numEntree" name="numEntree{{i}}" placeholder="Ex: E1234567" readonly />
                </div>

                <div class="form-row">
                    <label>Date d'arrivée / Arrival Date</label>
                    <input type="text" [(ngModel)]="form.dateArrivee" name="dateArrivee{{i}}" readonly />
                </div>

                <div class="form-row">
                    <label>Date de départ / Departure Date </label>
                    <input type="text" [(ngModel)]="form.dateDepart" name="dateDepart{{i}}" readonly />
                </div>

                <div class="form-row">
                    <label>N° Chambre / Room Number</label>
                    <input type="text" [(ngModel)]="form.numChambre" name="numChambre{{i}}"
                        [value]="resa?.roomName || form.numChambre" readonly />
                </div>

                <div class="form-row signature">
                    <label>Signature</label>
                    <input type="text" [(ngModel)]="form.signature" name="signature{{i}}"
                        placeholder="..................................." />
                </div>
            </form>
        </div>
    </div>

    <div class="modal-footer-actions">
        <button type="button" (click)="downloadPDF()" class="btn-download">
            Télécharger PDF
        </button>
        <button type="button" (click)="printForms()" class="btn-print">
            Print
        </button>
    </div>
</div>